import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [{
	path: "/",
	name: "login",
	component: () => import("@/views/login"),
}, {
	path: "/home",
	name: "home",
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/index/index',
		name: 'index',
		component: () => import( /* 首页 */ "@/views/index/index"),
	},{
		path: '/index/accountlist',
		name: 'accountlist',
		component: () => import( /* 账户管理-本单位 */ "@/views/index/accountlist"),
	},{
		path: '/index/accountlistxj',
		name: 'accountlistxj',
		component: () => import( /* 账户管理-下级单位 */ "@/views/index/accountlistxj"),
	},{
		path: '/index/commerciallist',
		name: 'commerciallist',
		component: () => import( /* 商户管理-已接收 */ "@/views/index/commerciallist"),
	},{
		path: '/index/commerciallists',
		name: 'commerciallists',
		component: () => import( /* 商户管理-待接收 */ "@/views/index/commerciallists"),
	}]
}];
const router = new VueRouter({
	routes,
});
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
	// chrome
	document.body.scrollTop = 0
	// firefox
	document.documentElement.scrollTop = 0
	// safari
	window.pageYOffset = 0
})
export default router;